(() => {
  let turnstileLoader;
  const loadTurnstile = () => turnstileLoader ||= new Promise((resolve, reject) => {
    if (window.turnstile) return resolve(window.turnstile);
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.onload = () => window.turnstile ? resolve(window.turnstile) : reject(new Error('Not ready'));
    script.onerror = () => { turnstileLoader = null; script.remove(); reject(new Error('Not ready')); };
    document.head.append(script);
  });
  document.querySelectorAll('[data-royal-review-form]').forEach((form) => {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const status = form.querySelector('[data-review-status]');
    const button = form.querySelector('[type="submit"]');
    const fields = form.querySelector('[data-review-fields]');
    const again = form.querySelector('[data-review-again]');
    const submitLabel = button.textContent;
    const notify = (tone, title, message, focus = false) => {
      const icon = document.createElement('span');
      icon.className = 'royal-review-notice__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = tone === 'success' ? '✓' : tone === 'error' ? '!' : 'i';
      const copy = document.createElement('div');
      const heading = document.createElement('strong');
      heading.textContent = title;
      const body = document.createElement('p');
      body.textContent = message;
      copy.append(heading, body);
      status.dataset.tone = tone;
      status.replaceChildren(icon, copy);
      if (focus) {
        status.focus({preventScroll:true});
        status.scrollIntoView({block:'nearest', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
    };
    again?.addEventListener('click', () => {
      if (fields) fields.hidden = false;
      status.replaceChildren();
      again.hidden = true;
      form.elements.author_display_name.focus();
    });
    const radios = [...form.querySelectorAll('input[name="rating"]')];
    const description = form.querySelector('[data-rating-description]');
    const updateStars = () => {
      const value = Number(radios.find((radio) => radio.checked)?.value || 0);
      radios.forEach((radio) => radio.closest('label').classList.toggle('is-selected', Number(radio.value) <= value));
      description.textContent = value ? `${value} / 5` : '';
    };
    radios.forEach((radio) => radio.addEventListener('change', updateStars));
    const enabled = form.dataset.enabled === 'true';
    let token = '';
    let widget;
    let widgetSize;
    let preparing;
    const prepare = () => preparing ||= loadTurnstile().then((api) => {
      widgetSize = form.querySelector('[data-review-spam-check]').clientWidth < 300 ? 'compact' : 'flexible';
      widget = api.render(form.querySelector('[data-review-spam-check]'), {
        sitekey: form.dataset.siteKey, action: 'royal_review', theme: 'light', size: widgetSize,
        callback: (value) => { token = value; },
        'expired-callback': () => { token = ''; },
        'error-callback': () => { token = ''; if (!fields?.hidden) notify('error', 'Yoxlama alınmadı', 'Bir az sonra yenidən cəhd edin.'); },
      });
    }).catch(() => { preparing = null; notify('error', 'Yoxlama yüklənmədi', 'Bir az sonra yenidən cəhd edin.'); });
    const adaptWidget = () => {
      if (sending || fields?.hidden || widget === undefined || !window.turnstile) return;
      const size = form.querySelector('[data-review-spam-check]').clientWidth < 300 ? 'compact' : 'flexible';
      if (size === widgetSize) return;
      window.turnstile.remove(widget);
      widget = undefined;
      token = '';
      preparing = null;
      prepare();
    };
    // The anti-spam script loads only when someone reaches the review form.
    if (enabled) {
      form.addEventListener('focusin', prepare, {once:true});
      if ('ResizeObserver' in window) new ResizeObserver(adaptWidget).observe(form.querySelector('[data-review-spam-check]'));
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) { observer.disconnect(); prepare(); }
        }, {rootMargin:'300px'});
        observer.observe(form);
      }
    }
    const keyName = `royal-review-key:${form.elements.product_id.value}`;
    let key;
    try { key = sessionStorage.getItem(keyName); } catch {}
    key ||= crypto.randomUUID();
    try { sessionStorage.setItem(keyName, key); } catch {}
    let sending = false;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (sending) return;
      if (form.dataset.enabled !== 'true' || !form.getAttribute('action')?.startsWith('/apps/')) return;
      if (!form.reportValidity()) return;
      if (!token) { prepare(); notify('info', 'Yoxlama tamamlanır', 'Bir neçə saniyə gözləyib yenidən göndərin.'); return; }
      sending = true;
      button.disabled = true;
      button.textContent = 'Göndərilir…';
      button.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 40000);
      status.replaceChildren();
      try {
        const payload = Object.fromEntries(new FormData(form));
        // Turnstile injects a rotating field. It is not part of review identity.
        delete payload['cf-turnstile-response'];
        payload.rating = Number(payload.rating);
        const fingerprint = Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(payload)))), (byte) => byte.toString(16).padStart(2, '0')).join('');
        try {
          const previous = sessionStorage.getItem(`${keyName}:hash`);
          if (previous && previous !== fingerprint) key = crypto.randomUUID();
          sessionStorage.setItem(keyName, key);
          sessionStorage.setItem(`${keyName}:hash`, fingerprint);
        } catch {}
        payload.idempotency_key = key;
        payload.turnstile_token = token;
        const response = await fetch(form.action, {method: 'POST', credentials: 'same-origin', signal:controller.signal, headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(payload)});
        const result = await response.json();
        if (!response.ok || !['approved', 'pending'].includes(result.status)) throw new Error('Not accepted');
        form.reset();
        updateStars();
        key = crypto.randomUUID();
        try { sessionStorage.setItem(keyName, key); sessionStorage.removeItem(`${keyName}:hash`); } catch {}
        if (fields) fields.hidden = true;
        if (again) again.hidden = false;
        notify('success', 'Təşəkkür edirik!', result.status === 'approved' ? 'Rəyiniz məhsul səhifəsində dərc edildi.' : 'Rəyiniz göndərildi. Təsdiqdən sonra görünəcək.', true);
      } catch {
        notify('error', 'Rəy göndərilmədi', form.dataset.error, true);
      } finally {
        clearTimeout(timeout);
        token = '';
        try { if (widget !== undefined && window.turnstile) window.turnstile.reset(widget); } catch { preparing = null; }
        sending = false;
        adaptWidget();
        button.disabled = false;
        button.textContent = submitLabel;
        button.removeAttribute('aria-busy');
      }
    });
  });
})();
